<br><br><div class="container">
    <div class="col-xs-12">
        <div class="animated fadeIn mt-5">
            <form [formGroup]="updatedProfile" name="updatedProfile" id="updatedProfile" (ngSubmit)="updateProfiledata(updatedProfile.value)"
            autocomplete="off" novalidate>
                <h2 style="margin-bottom: 3px;margin-top: 24px; font-size: 0.9970rem">Please reset your password</h2>
                <br>
                <div class="input-group-lg">
                   
                    <div class="row">
                        <!-- <div class="col-md-4">
                            <mat-form-field class="w-100">
                                <input matInput formControlName="Password" name="Password" placeholder="Existing Password"
                                    type="password">
                                <mat-error *ngIf="updatedProfile.controls.Password.invalid">
                                    Please enter Existing Password
                                </mat-error>
                            </mat-form-field>                
                        </div> -->
                        <div class="col-md-4">
                            <mat-form-field class="w-100">
                                <input matInput formControlName="ModifyPassword" name="ModifyPassword" placeholder="New Password"
                                    type="password">
                                <mat-error
                                    *ngIf="updatedProfile.controls.ModifyPassword.invalid && updatedProfile.controls.ModifyPassword.value.length>0">
                                    Password should contain at least one uppercase letter,
                                    one lowercase letter, one number and one special character and minimum 8 and maximum 20 characters,
                                </mat-error>
                            </mat-form-field>
                
                        </div>
                        <div class="col-md-4" *ngIf="updatingPassword">
                            <mat-form-field class="w-100">
                                <input matInput formControlName="ConfirmPassword" name="ConfirmPassword" placeholder="Confirm Password"
                                    type="password">
                                <mat-error
                                    *ngIf="updatedProfile.controls.ModifyPassword.value !== updatedProfile.controls.ConfirmPassword.value">
                                    Not a match
                                </mat-error>
                            </mat-form-field>                
                        </div>
                    </div>
                </div>
                <!-- <br>
                <button mat-flat-button color="accent" type="submit">Update Password</button>
                <button mat-flat-button color="primary"  (click)=cancel()>Cancel</button>
                <br> -->
                <br>
           
  
            <!-- <form [formGroup]="resetQuestions" name="resetQuestions" (ngSubmit)="setSecurityQuestions(resetQuestions.value)" style="border: transparent;"> -->
  
  
  <div style="margin-top:2rem;" class="cent">
    <button mat-flat-button color="primary" type="submit" class="loginbtn mr-2">Save and Proceed</button>&nbsp;
    <button mat-flat-button color="accent" type="button" (click)="cancel()" class="loginbtn">Cancel</button>
  </div>
   
  </form>
        </div>
    </div>
  </div>
